import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TodayFollowupLayer from "../components/TodayFollowupLayer";

const TodayFollowupPage = () => {
    return (
        <MasterLayout>
            <TodayFollowupLayer />
        </MasterLayout>
    );
};

export default TodayFollowupPage;
